import { ComponentFeature } from "types/CMS/KontentAI/content-types/feature";
import { assetResolver } from "./asset";
import { feature } from "types/CMS/Unum/feature";
import { richTextResolver } from "./richText";
import { CtaResolver } from "./cta";
import { getUuid } from "utils/util";
import { createResolver } from "./Factories/ResolverFactory";
import { productTaxonomyResolver } from "./products";

export const featureResolver = createResolver({
  resolve: (feature: ComponentFeature): feature => {
    return {
      isFilterable: true,
      productTaxonomy: productTaxonomyResolver.resolve(
        feature.elements.products
      ).result,
      key: getUuid(),
      type: "feature",
      title: feature.elements.title.value,
      body: richTextResolver.resolve(feature.elements.body).result,
      layout: layoutResolver.resolve(feature.elements.layout.value[0].codename)
        .result,
      asset: assetResolver.resolve(feature.elements.asset.linkedItems[0])
        .result,
      cta: CtaResolver.resolve(feature.elements.ctas.linkedItems).result,
    };
  },
});

export const layoutResolver = createResolver({
  resolve: (layout: "trailing_asset" | "leading_asset") => {
    switch (layout) {
      case "leading_asset":
        return "left";
      case "trailing_asset":
        return "right";
      default:
        return "center";
    }
  },
});
